import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "@babel/runtime/helpers/esm/get";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { DOM } from '@antv/l7-utils';
import { get } from 'lodash'; // import { Container } from 'inversify';

import Popup from "./popup";
export { LayerPopup };

var LayerPopup = /*#__PURE__*/function (_Popup) {
  _inherits(LayerPopup, _Popup);

  var _super = _createSuper(LayerPopup);

  function LayerPopup() {
    var _this;

    _classCallCheck(this, LayerPopup);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "layerConfigMap", new WeakMap());

    return _this;
  }

  _createClass(LayerPopup, [{
    key: "layerConfigItems",
    get: function get() {
      var _ref;

      var _this$popupOption = this.popupOption,
          config = _this$popupOption.config,
          items = _this$popupOption.items;
      return (_ref = config !== null && config !== void 0 ? config : items) !== null && _ref !== void 0 ? _ref : [];
    }
  }, {
    key: "addTo",
    value: function addTo(scene) {
      _get(_getPrototypeOf(LayerPopup.prototype), "addTo", this).call(this, scene);

      this.bindLayerEvent();
      this.hide();
      return this;
    }
  }, {
    key: "remove",
    value: function remove() {
      _get(_getPrototypeOf(LayerPopup.prototype), "remove", this).call(this);

      this.unbindLayerEvent();
      return this;
    }
  }, {
    key: "setOptions",
    value: function setOptions(option) {
      this.unbindLayerEvent();

      _get(_getPrototypeOf(LayerPopup.prototype), "setOptions", this).call(this, option);

      this.bindLayerEvent();
      return this;
    }
  }, {
    key: "getDefault",
    value: function getDefault(option) {
      var isClickTrigger = option.trigger === 'click';
      return _objectSpread(_objectSpread({}, _get(_getPrototypeOf(LayerPopup.prototype), "getDefault", this).call(this, option)), {}, {
        trigger: 'hover',
        followCursor: !isClickTrigger,
        lngLat: {
          lng: 0,
          lat: 0
        },
        offsets: [0, 10],
        closeButton: false,
        closeOnClick: false,
        autoClose: false,
        closeOnEsc: false
      });
    }
    /**
     * 绑定对应的图层事件
     * @protected
     */

  }, {
    key: "bindLayerEvent",
    value: function bindLayerEvent() {
      var _this2 = this;

      var trigger = this.popupOption.trigger;
      this.layerConfigItems.forEach(function (configItem) {
        var _layer$getSource;

        var layer = _this2.getLayerByConfig(configItem);

        if (!layer) {
          return;
        }

        var layerInfo = _objectSpread({}, configItem);

        if (trigger === 'hover') {
          var onMouseMove = _this2.onLayerMouseMove.bind(_this2, layer);

          var onMouseOut = _this2.onLayerMouseOut.bind(_this2, layer);

          layerInfo.onMouseMove = onMouseMove;
          layerInfo.onMouseOut = onMouseOut;
          layer === null || layer === void 0 ? void 0 : layer.on('mousemove', onMouseMove);
          layer === null || layer === void 0 ? void 0 : layer.on('mouseout', onMouseOut);
        } else {
          var onClick = _this2.onLayerClick.bind(_this2, layer);

          layerInfo.onClick = onClick;
          layer === null || layer === void 0 ? void 0 : layer.on('click', onClick);
        }

        var source = layer === null || layer === void 0 ? void 0 : (_layer$getSource = layer.getSource) === null || _layer$getSource === void 0 ? void 0 : _layer$getSource.call(layer);

        var onSourceUpdate = _this2.onSourceUpdate.bind(_this2, layer);

        source === null || source === void 0 ? void 0 : source.on('update', onSourceUpdate);
        layerInfo.onSourceUpdate = onSourceUpdate;

        _this2.layerConfigMap.set(layer, layerInfo);
      });
    }
    /**
     * 解绑对应的图层事件
     * @protected
     */

  }, {
    key: "unbindLayerEvent",
    value: function unbindLayerEvent() {
      var _this3 = this;

      this.layerConfigItems.forEach(function (configItem) {
        var layer = _this3.getLayerByConfig(configItem);

        var layerInfo = layer && _this3.layerConfigMap.get(layer);

        if (!layerInfo) {
          return;
        }

        var onMouseMove = layerInfo.onMouseMove,
            onMouseOut = layerInfo.onMouseOut,
            onClick = layerInfo.onClick,
            onSourceUpdate = layerInfo.onSourceUpdate;

        if (onMouseMove) {
          layer.off('mousemove', onMouseMove);
        }

        if (onMouseOut) {
          layer.off('mouseout', onMouseOut);
        }

        if (onClick) {
          layer.off('click', onClick);
        }

        if (onSourceUpdate) {
          var _layer$getSource2;

          layer === null || layer === void 0 ? void 0 : (_layer$getSource2 = layer.getSource()) === null || _layer$getSource2 === void 0 ? void 0 : _layer$getSource2.off('update', onSourceUpdate);
        }
      });
    }
  }, {
    key: "onLayerMouseMove",
    value: function onLayerMouseMove(layer, e) {
      if (!this.isSameFeature(layer, e.featureId)) {
        var _this$getLayerInfoFra = this.getLayerInfoFrag(layer, e),
            title = _this$getLayerInfoFra.title,
            content = _this$getLayerInfoFra.content;

        this.setDOMContent(content);
        this.setTitle(title);
        this.displayFeatureInfo = {
          layer: layer,
          featureId: e.featureId
        };
        this.show();
      }
    } // eslint-disable-next-line @typescript-eslint/no-unused-vars

  }, {
    key: "onLayerMouseOut",
    value: function onLayerMouseOut(layer, e) {
      this.displayFeatureInfo = undefined;

      if (this.isShow) {
        this.hide();
      }
    }
  }, {
    key: "onLayerClick",
    value: function onLayerClick(layer, e) {
      if (this.isShow && this.isSameFeature(layer, e.featureId)) {
        this.hide();
      } else {
        var _this$getLayerInfoFra2 = this.getLayerInfoFrag(layer, e),
            title = _this$getLayerInfoFra2.title,
            content = _this$getLayerInfoFra2.content;

        this.setDOMContent(content);
        this.setLnglat(e.lngLat);
        this.setTitle(title);
        this.displayFeatureInfo = {
          layer: layer,
          featureId: e.featureId
        };
        this.show();
      }
    }
  }, {
    key: "onSourceUpdate",
    value: function onSourceUpdate(layer) {
      var _this$displayFeatureI;

      if (((_this$displayFeatureI = this.displayFeatureInfo) === null || _this$displayFeatureI === void 0 ? void 0 : _this$displayFeatureI.layer) === layer) {
        this.hide();
        this.displayFeatureInfo = undefined;
      }
    }
    /**
     * 通过当前图层和对应选中的元素获取气泡展示的 HTML 内容
     * @param layer
     * @param e
     * @protected
     */

  }, {
    key: "getLayerInfoFrag",
    value: function getLayerInfoFrag(layer, e) {
      var layerInfo = this.layerConfigMap.get(layer);
      var titleFrag;
      var contentFrag = document.createDocumentFragment();

      if (layerInfo) {
        var _feature = e.feature;

        if (_feature.type === 'Feature' && 'properties' in _feature && 'geometry' in _feature) {
          _feature = _feature.properties;
        }

        var title = layerInfo.title,
            fields = layerInfo.fields,
            customContent = layerInfo.customContent;

        if (title) {
          titleFrag = document.createDocumentFragment();
          var titleElement = title instanceof Function ? title(_feature) : title;
          DOM.appendElementType(titleFrag, titleElement);
        }

        if (customContent) {
          var content = customContent instanceof Function ? customContent(_feature) : customContent;
          DOM.appendElementType(contentFrag, content);
        } else if (fields !== null && fields !== void 0 && fields.length) {
          fields === null || fields === void 0 ? void 0 : fields.forEach(function (fieldConfig) {
            var _ref3, _ref4;

            var _ref2 = typeof fieldConfig === 'string' ? // tslint:disable-next-line:no-object-literal-type-assertion
            {
              field: fieldConfig
            } : fieldConfig,
                field = _ref2.field,
                formatField = _ref2.formatField,
                formatValue = _ref2.formatValue,
                getValue = _ref2.getValue;

            var row = DOM.create('div', 'l7-layer-popup__row');
            var value = getValue ? getValue(e.feature) : get(_feature, field);
            var fieldElement = (_ref3 = formatField instanceof Function ? formatField(field, _feature) : formatField) !== null && _ref3 !== void 0 ? _ref3 : field;
            var valueElement = (_ref4 = formatValue instanceof Function ? formatValue(value, _feature) : formatValue) !== null && _ref4 !== void 0 ? _ref4 : value;
            var fieldSpan = DOM.create('span', 'l7-layer-popup__key', row);
            DOM.appendElementType(fieldSpan, fieldElement);
            DOM.appendElementType(fieldSpan, document.createTextNode('：'));
            var valueSpan = DOM.create('span', 'l7-layer-popup__value', row);
            DOM.appendElementType(valueSpan, valueElement);
            contentFrag.appendChild(row);
          });
        }
      }

      return {
        title: titleFrag,
        content: contentFrag
      };
    }
    /**
     * 通过 Layer 配置访问到真实的 Layer 实例
     * @param configItem
     * @protected
     */

  }, {
    key: "getLayerByConfig",
    value: function getLayerByConfig(configItem) {
      var layer = configItem.layer;

      if (layer instanceof Object) {
        return layer;
      }

      if (typeof layer === 'string') {
        return this.layerService.getLayer(layer) || this.layerService.getLayerByName(layer);
      }
    }
    /**
     * 判断当前展示的 Feature 是否和上一次查看的一致
     * @param layer
     * @param featureId
     * @protected
     */

  }, {
    key: "isSameFeature",
    value: function isSameFeature(layer, featureId) {
      var displayFeatureInfo = this.displayFeatureInfo;
      return displayFeatureInfo && layer === displayFeatureInfo.layer && featureId === displayFeatureInfo.featureId;
    }
  }]);

  return LayerPopup;
}(Popup);

export { LayerPopup as default };